module.exports = __webpack_public_path__ + "img/6.bb8b9a40.png";